import IV from "./iv";

const ModuleName = "tfApp.account-opening";
export default angular.module(ModuleName, [IV(ModuleName)])
                      .name;
